import * as Assets from "../../utils/svg_assets";

const NotFound = (props) => {
  const { title, subTitle, img = Assets.iNotFound } = props;

  return (
    <div className="centered">
      <div className="text-primary-danger">{title}</div>
      <div className="my-4">
        <img src={img} alt="ilustrator not found" />
      </div>
      <div>{subTitle}</div>
    </div>
  );
};

export default NotFound;
